import Papa from 'papaparse';

/**
 * Parses CSV string into structured JSON objects
 * Maps standard headers to Intuitus Internal Keys
 */
export const parseIdentityCSV = (csvString) => {
  return new Promise((resolve, reject) => {
    Papa.parse(csvString, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        // Map common CSV header variations to our internal keys
        const mappedData = results.data.map(row => ({
          sourceUserID: row.sourceUserID || row.id || row.user_id || row.email,
          sourceMemberID: row.sourceMemberID || row.member_id,
          sourceMembershipID: row.sourceMembershipID || row.membership_id,
          sourceEmail: row.sourceEmail || row.email,
          sourceAltEmail1: row.sourceAltEmail1 || row.secondary_email,
          firstName: row.firstName || row.first_name,
          lastName: row.lastName || row.last_name,
          sourceAltId1: row.sourceAltId1,
          sourceAltId2: row.sourceAltId2,
          sourceAltId3: row.sourceAltId3,
          postalCode: row.postalCode || row.zip,
          state: row.state,
          membershipType: row.membershipType || row.plan,
          membershipStatus: row.membershipStatus || row.status,
          userGroup: row.userGroup || 'customers'
        }));
        resolve(mappedData);
      },
      error: (error) => reject(error)
    });
  });
};

/**
 * Generates a comprehensive CSV template with all supported fields
 */
export const generateCSVTemplate = () => {
  const headers = [
    'sourceUserID',
    'firstName',
    'lastName',
    'sourceEmail',
    'sourceMemberID',
    'sourceMembershipID',
    'sourceAltEmail1',
    'sourceAltId1',
    'sourceAltId2',
    'sourceAltId3',
    'postalCode',
    'state',
    'membershipType',
    'membershipStatus',
    'userGroup'
  ];
  
  const sampleRow = [
    'USR-99210',
    'Sarah',
    'Chen',
    'sarah.c@techcorp.io',
    'MEM-882',
    'PLATINUM-V3',
    'personal.sarah@gmail.com',
    'LEGACY_ID_01',
    'CRM_KEY_99',
    'EXT_REF_A',
    '10012',
    'NY',
    'Platinum',
    'Active',
    'customers'
  ];

  const adminRow = [
    'ADM-001',
    'Alex',
    'Jordan',
    'alex@intuitus.io',
    'STAFF-01',
    'INTERNAL',
    '',
    '',
    '',
    '',
    '94103',
    'CA',
    'Admin',
    'Active',
    'administrators'
  ];

  return [
    headers.join(','),
    sampleRow.join(','),
    adminRow.join(',')
  ].join('\n');
};